import React, { createContext, useContext } from 'react';
import { useChatContext } from './ChatContext';
import { useAuth } from './AuthContext';
import { useWebRTC } from '../hooks/useWebRTC';

const CallContext = createContext(null);

export function CallProvider({ children }) {
  const { socketRef, conversations } = useChatContext();
  const { user } = useAuth();
  const webrtc = useWebRTC(socketRef, user);

  return (
    <CallContext.Provider value={{ ...webrtc, conversations }}>
      {children}
    </CallContext.Provider>
  );
}

export function useCallContext() {
  const ctx = useContext(CallContext);
  if (!ctx) throw new Error('useCallContext must be used within CallProvider');
  return ctx;
}
